<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">광고관리</span>
            <span class="txt">
                회원이 출석 체크를 하는 터치모니터의 화면 전환 및 입장 후 자동 퇴실시간 적용 등 터치모니터를 이용한
                출석체크 관련 내용을 설정합니다.
            </span>
        </div>

        <div class="com-table-top">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">
                        터치모니터 광고 (최대 5개)
                        <small>센터가 사용하는 터치모니터의 기본배경으로 노출합니다.</small>
                    </span>
                </div>
                <div class="right-box">
                    <a
                        class="com-btn blue"
                        href="#"
                        @click="
                            adPop = true;
                            adType = 1;
                        "
                    >
                        배너등록
                    </a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 220px" />
                    <col style="width: 470px" />
                    <col style="width: 280px" />
                    <col style="width: 200px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>이미지</th>
                        <th>링크</th>
                        <th>수정</th>
                    </tr>
                </thead>
                <tbody
                    v-if="
                        dataTouch.centerImage1 ||
                        dataTouch.centerImage2 ||
                        dataTouch.centerImage3 ||
                        dataTouch.centerImage4 ||
                        dataTouch.centerImage5
                    "
                >
                    <template v-for="(item, index) in [1, 2, 3, 4, 5]">
                        <tr v-if="dataTouch[`centerImage${item}`]" :key="index">
                            <td>{{ item }}번</td>
                            <td>
                                <span class="ad-photo">
                                    <img :src="dataTouch[`centerImage${item}`]" alt="" />
                                </span>
                            </td>
                            <td>-</td>
                            <td>
                                <button class="com-btn" type="button">수정</button>
                                <button class="com-btn red" type="button" @click="removeTouchImage(item)">삭제</button>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">
                        관리자 PC 광고 (최대 3개)
                        <small>센터 admin 좌측메뉴 하단에 노출합니다.</small>
                    </span>
                </div>
                <div class="right-box">
                    <button class="com-btn blue" type="button" @click="add(2)">배너등록</button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 220px" />
                    <col style="width: 470px" />
                    <col style="width: 280px" />
                    <col style="width: 200px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>이미지</th>
                        <th>링크</th>
                        <th>수정</th>
                    </tr>
                </thead>
                <tbody v-if="data.adminWeb1Url || data.adminWeb2Url || data.adminWeb3Url">
                    <tr v-if="data.adminWeb1Url">
                        <td>1번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.adminWeb1Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.adminWeb1Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(2, 1)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(2, 1)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="data.adminWeb2Url">
                        <td>2번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.adminWeb2Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.adminWeb2Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(2, 2)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(2, 2)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="data.adminWeb3Url">
                        <td>3번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.adminWeb3Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.adminWeb3Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(2, 3)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(2, 3)">삭제</button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">
                        관리자 APP 광고 (최대 3개)
                        <small>APP에서 관리자가 접속 시 광고영역에 보여줍니다.</small>
                    </span>
                </div>
                <div class="right-box">
                    <button
                        :disabled="data.adminApp1Url && data.adminApp2Url && data.adminApp3Url"
                        class="com-btn blue"
                        type="button"
                        @click="add(3)"
                    >
                        배너등록
                    </button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 220px" />
                    <col style="width: 470px" />
                    <col style="width: 280px" />
                    <col style="width: 200px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>이미지</th>
                        <th>링크</th>
                        <th>수정</th>
                    </tr>
                </thead>
                <tbody v-if="data.adminApp1Url || data.adminApp2Url || data.adminApp3Url">
                    <tr v-if="data.adminApp1Url">
                        <td>1번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.adminApp1Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.adminApp1Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(3, 1)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(3, 1)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="data.adminApp2Url">
                        <td>2번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.adminApp2Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.adminApp2Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(3, 2)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(3, 2)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="data.adminApp3Url">
                        <td>3번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.adminApp3Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.adminApp3Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(3, 3)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(3, 3)">삭제</button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">
                        회원 APP 광고 (최대 3개)
                        <small>APP에서 회원이 접속 시 광고영역에 보여줍니다.</small>
                    </span>
                </div>
                <div class="right-box">
                    <button
                        :disabled="data.custApp1Url && data.custApp2Url && data.custApp3Url"
                        class="com-btn blue"
                        type="button"
                        @click="add(4)"
                    >
                        배너등록
                    </button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 220px" />
                    <col style="width: 470px" />
                    <col style="width: 280px" />
                    <col style="width: 200px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>이미지</th>
                        <th>링크</th>
                        <th>수정</th>
                    </tr>
                </thead>
                <tbody v-if="data.custApp1Url || data.custApp2Url || data.custApp3Url">
                    <tr v-if="data.custApp1Url">
                        <td>1번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.custApp1Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.custApp1Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(4, 1)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(4, 1)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="data.custApp2Url">
                        <td>2번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.custApp2Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.custApp2Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(4, 2)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(4, 2)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="data.custApp3Url">
                        <td>3번</td>
                        <td>
                            <span class="ad-photo">
                                <img :src="data.custApp3Url" alt="" />
                            </span>
                        </td>
                        <td>{{ data.custApp3Link }}</td>
                        <td>
                            <button class="com-btn" type="button" @click="edit(4, 3)">수정</button>
                            <button class="com-btn red" type="button" @click="removeBanner(4, 3)">삭제</button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- <div class="bottom-btn">
            <button class="com-btn blue">저장</button>
        </div> -->

        <!-- 체인점 등록 레이어 팝업 -->
        <div v-show="adPop" class="layer-pop square">
            <div class="view-content w655">
                <button class="close" @click="adPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">
                        <span v-if="adType == 1">터치모니터 광고배너 등록</span>
                        <span v-if="adType == 2">관리자 PC 광고배너 등록</span>
                        <span v-if="adType == 3">관리자 APP 광고배너 등록</span>
                        <span v-if="adType == 4">회원 APP 광고배너 등록</span>
                    </span>
                    <div v-for="(item, index) in uploads" :key="index" class="advert-box">
                        <div class="del-btn">
                            <button v-if="index > 0" class="del" @click="uploads.splice(index, 1)">
                                <span class="blind">삭제하기</span>
                            </button>
                        </div>
                        <table class="com-table col-style-2 advert">
                            <colgroup>
                                <col style="width: 160px" />
                                <col style="width: 390px" />
                            </colgroup>
                            <tbody>
                                <tr v-if="adType > 1">
                                    <td>이름 {{ item.index }}</td>
                                    <td>
                                        <input v-model="item.name" class="w100p" type="text" />
                                    </td>
                                </tr>
                                <tr v-if="adType > 1">
                                    <td>연결링크</td>
                                    <td>
                                        <input v-model="item.link" class="w100p" type="text" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>이미지</td>
                                    <td>
                                        <div class="add-file-box">
                                            <input
                                                :id="`addFile-${item.index}`"
                                                type="file"
                                                @change="(e) => fileSelect(e, index)"
                                            />
                                            <label :for="`addFile-${item.index}`">첨부하기</label>
                                            <span v-if="adType == 1" class="txt">권장사이즈 : 1130 X 1200 px</span>
                                            <span v-if="adType == 2" class="txt">권장사이즈 : 224 X 100 px</span>
                                            <span v-if="adType == 3" class="txt">권장사이즈 : 224 X 100 px</span>
                                            <span v-if="adType == 4" class="txt">권장사이즈 : 224 X 100 px</span>
                                        </div>
                                        <div v-if="item.filename" class="img-box">
                                            <img :src="`data:${item.mimetype};base64,${item.base64data}`" alt="" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="isUploadable" class="bottom-add-btn">
                        <button class="add-btn" @click="addAdImage">+ 추가</button>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="adPop = false">취소</button>
                        <button class="com-btn blue" @click="uploadImages">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 체인점 수정 레이어 팝업 -->
        <div v-show="adEditPop" class="layer-pop square">
            <div class="view-content w655">
                <button class="close" @click="adEditPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">
                        <span v-if="adType == 1">터치모니터 광고배너 수정</span>
                        <span v-if="adType == 2">관리자 PC 광고배너 수정</span>
                        <span v-if="adType == 3">관리자 APP 광고배너 수정</span>
                        <span v-if="adType == 4">회원 APP 광고배너 수정</span>
                    </span>
                    <div class="advert-box">
                        <table class="com-table col-style-2 advert">
                            <colgroup>
                                <col style="width: 160px" />
                                <col style="width: 390px" />
                            </colgroup>
                            <tbody>
                                <tr v-if="adType > 1">
                                    <td>이름 {{ dataEdit.index }}</td>
                                    <td>
                                        <input v-model="dataEdit.name" class="w100p" type="text" />
                                    </td>
                                </tr>
                                <tr v-if="adType > 1">
                                    <td>연결링크</td>
                                    <td>
                                        <input v-model="dataEdit.link" class="w100p" type="text" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>이미지</td>
                                    <td>
                                        <div class="add-file-box">
                                            <input id="editFile" type="file" @change="editFileSelect" />
                                            <label for="editFile">첨부하기</label>
                                            <span v-if="adType == 1" class="txt">권장사이즈 : 1130 X 1200 px</span>
                                            <span v-if="adType == 2" class="txt">권장사이즈 : 224 X 100 px</span>
                                            <span v-if="adType == 3" class="txt">권장사이즈 : 224 X 100 px</span>
                                            <span v-if="adType == 4" class="txt">권장사이즈 : 224 X 100 px</span>
                                        </div>
                                        <div v-if="dataEdit.url" class="img-box">
                                            <img :src="dataEdit.image || dataEdit.url" alt="" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="bottom-btn">
                    <btn-loading-spinner v-if="isSaving"></btn-loading-spinner>
                    <template v-else>
                        <button class="com-btn" @click="adEditPop = false">취소</button>
                        <button class="com-btn blue" @click="save">저장</button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';

export default {
    name: 'SettingAdvertisement',
    components: { LoadingSpinner, BtnLoadingSpinner },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        isUploadable() {
            if (this.adType == 1) {
                return !(
                    this.dataTouch.centerImage1 &&
                    this.dataTouch.centerImage2 &&
                    this.dataTouch.centerImage3 &&
                    this.dataTouch.centerImage4 &&
                    this.dataTouch.centerImage5
                );
            } else {
                return (
                    Boolean(this.data[`${this.fields[this.adType]}1Url`]) +
                        Boolean(this.data[`${this.fields[this.adType]}2Url`]) +
                        Boolean(this.data[`${this.fields[this.adType]}3Url`]) +
                        this.uploads.length <
                    3
                );
            }
        },
    },
    data() {
        return {
            adType: 0, //광고 배너 타입 (0: 터치모니터, 1:관리자 pc관고, 2:관리자 app 광고, 3:회원 APP 광고)
            adPop: false, //광고 등록 팝업
            adEditPop: false, //광고 수정 팝업
            loginCenterId: '',
            isLoading: false,
            isSaving: false,
            centerStaffId: this.$route.params.centerStaffId,
            fields: ['', '', 'adminWeb', 'adminApp', 'custApp'],
            uploads: [{}],
            data: {
                adminWeb1Name: '',
                adminWeb1Url: '',
                adminWeb1Link: '',
                adminWeb2Name: '',
                adminWeb2Url: '',
                adminWeb2Link: '',
                adminWeb3Name: '',
                adminWeb3Url: '',
                adminWeb3Link: '',
                adminApp1Name: '',
                adminApp1Url: '',
                adminApp1Link: '',
                adminApp2Name: '',
                adminApp2Url: '',
                adminApp2Link: '',
                adminApp3Name: '',
                adminApp3Url: '',
                adminApp3Link: '',
                custApp1Name: '',
                custApp1Url: '',
                custApp1Link: '',
                custApp2Name: '',
                custApp2Url: '',
                custApp2Link: '',
                custApp3Name: '',
                custApp3Url: '',
                custApp3Link: '',
            },
            dataTouch: {
                centerId: '',
                centerImage1: '',
                centerImage2: '',
                centerImage3: '',
                centerImage4: '',
                centerImage5: '',
            },
            dataEdit: {},
        };
    },
    beforeMount() {
        this.loginCenterId = '0'; //parseInt(this.cId);
        // if (this.loginCenterId == 0) {
        //     location.href = '/login';
        // }
        this.data.centerId = this.loginCenterId;
        this.dataTouch.centerId = this.loginCenterId;
        this.load();
    },
    mounted() {},
    methods: {
        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        async fileSet(file) {
            if (file === null) return null;
            let base64data = await this.readFileAsync(file);
            base64data = base64data.split(',')[1];
            if (base64data === undefined) {
                alert('비어있는 파일은 첨부할 수 없습니다.');
                this.file = null;
                return;
            }
            return {
                filename: file.name,
                mimetype: file.type,
                base64data: base64data,
            };
        },
        load() {
            this.isLoading = true;
            api.get(`/admin/api/centerBanner/${this.loginCenterId}`)
                .then((res) => {
                    this.data = res.data;
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
            api.get(`/admin/api/centerTouchMonitorSetting/${this.loginCenterId}`)
                .then((res) => {
                    this.dataTouch = res.data;
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        removeTouchImage(index) {
            if (!confirm('배너 이미지를 삭제하시겠습니까?')) return;
            this.isLoading = true;
            api.delete(`/admin/api/centerTouchMonitorSetting/${this.loginCenterId}/${index}`)
                .then((res) => {
                    this.load();
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        removeBanner(type, index) {
            if (!confirm('배너 이미지를 삭제하시겠습니까?')) return;
            this.isLoading = true;
            api.post(`/admin/api/centerBanner/delete`, {
                centerId: this.data.centerId,
                imageDetail: [
                    {
                        imageType: ['', '', 'AW', 'AA', 'CA'][type],
                        imageNo: [index],
                    },
                ],
            })
                .then((res) => {
                    this.load();
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        async fileSelect(event, index) {
            const file = await this.fileSet(event.target.files[0]);
            file.name = this.uploads[index].name;
            file.link = this.uploads[index].link;
            this.uploads.splice(index, 1, file);
            this.$forceUpdate();
        },
        add(type) {
            this.adType = type;
            const item = this.fields[type];
            this.uploads = [];
            this.adPop = true;
            this.addAdImage();
        },
        addAdImage() {
            const item = this.fields[this.adType];
            for (let i = 1; i <= 3; i++) {
                if (!this.data[`${item}${i}Url`] && this.uploads.filter((o) => o.index == i).length == 0) {
                    this.uploads.push({ index: i });
                    return;
                }
            }
        },
        edit(type, index) {
            this.adType = type;
            const item = this.fields[type];
            this.dataEdit = {
                index,
                name: this.data[`${item}${index}Name`],
                link: this.data[`${item}${index}Link`],
                url: this.data[`${item}${index}Url`],
            };
            this.uploads = [];
            this.adEditPop = true;
        },
        async editFileSelect(event) {
            const file = await this.fileSet(event.target.files[0]);
            this.data[this.fields[this.adType] + this.dataEdit.index + 'Image'] = file;
            this.dataEdit.image = `data:${file.mimetype};base64,` + file.base64data;
            this.$forceUpdate();
        },
        save() {
            const key = this.fields[this.adType] + this.dataEdit.index;
            const data = { centerId: this.data.centerId };
            data[key + 'Name'] = this.dataEdit.name;
            data[key + 'Link'] = this.dataEdit.link;
            // data[key + 'Image'] = this.data[key + 'Image'];
            this.isSaving = true;
            if (this.adType == 1) {
            } else {
                api.put(`/admin/api/centerBanner`, data)
                    .then((res) => {
                        this.isSaving = false;
                        this.adEditPop = false;
                        this.load();
                    })
                    .catch((res) => {
                        this.isSaving = false;
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                        console.error(res);
                    });
            }
        },
        uploadImages() {
            this.isSaving = true;
            if (this.adType == 1) {
                this.uploads.forEach((o) => {
                    for (let i = 1; i <= 5; i++) {
                        if (!this.dataTouch[`centerImage${i}`] && o.filename) {
                            this.dataTouch[`centerImage${i}`] = o;
                            break;
                        }
                    }
                });
                api.post(`/admin/api/centerTouchMonitorSetting/create`, this.dataTouch)

                    .then((res) => {
                        this.adPop = false;
                        this.uploads = [{}];
                        this.load();
                    })
                    .catch((res) => {
                        this.isLoading = false;
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                        console.error(res);
                    });
            } else {
                const data = { centerId: this.data.centerId };
                console.log(this.uploads);
                this.uploads.forEach((o, i) => {
                    // for (let i = 1; i <= 3; i++) {
                    const key = `${this.fields[this.adType]}Image${i + 1}`;
                    if (!this.data[key] && !this.data[`${this.fields[this.adType]}${i}Url`] && o.filename) {
                        data[key] = o;
                        data[`${this.fields[this.adType]}Name${i + 1}`] = o.name;
                        data[`${this.fields[this.adType]}${i + 1}Link`] = o.link;
                        // break;
                        // }
                    }
                });

                api.post(`/admin/api/centerBanner`, data)
                    .then((res) => {
                        this.isSaving = false;
                        this.adPop = false;
                        this.uploads = [{}];
                        this.load();
                    })
                    .catch((res) => {
                        this.isSaving = false;
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                        console.error(res);
                    });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.bottom-btn {
    .spinner-container {
        margin: auto;
    }
}
</style>
